module.exports = __webpack_public_path__ + "img/305.d52aea08.gif";